const BLOB_BASE_URL = 'https://kyihojcogtccxga1.public.blob.vercel-storage.com'

// All product images are served from the shared piffl-assets Vercel Blob store; this repo keeps no local SVGs.
// In the store, `<name>.svg` is piffl-app's art. For the names below, admin's art differs from piffl-app's, and
// the art admin has always shown lives under the `__web` suffix (admin and piffl-web share it, byte-identical).
// Source of truth for the store contents and these overrides: piffl-web/scripts/product-images.manifest.json
const IMAGE_KEY_OVERRIDES: Readonly<Record<string, string>> = {
  basketball: 'basketball__web.svg',
  beach_football: 'beach_football__web.svg',
  beach_handball: 'beach_handball__web.svg',
  floorball: 'floorball__web.svg',
  football: 'football__web.svg',
  football_croquet: 'football_croquet__web.svg',
  gym_kit_freeweights_medicineball_foamroller: 'gym_kit_freeweights_medicineball_foamroller__web.svg',
  handball: 'handball__web.svg',
  kick_it: 'kick_it__web.svg',
  medicine_ball: 'medicine_ball__web.svg',
  mini_beach_lacrosse: 'mini_beach_lacrosse__web.svg',
  mini_ski_skates: 'mini_ski_skates__web.svg',
  sno_kids_ski_set: 'sno_kids_ski_set__web.svg',
  snow_rider: 'snow_rider__web.svg',
  volleyball: 'volleyball__web.svg',
  wingman_pro: 'wingman_pro__web.svg',
}

export const getProductImageUrl = (imageName: string | undefined): string | undefined => {
  if (!imageName) {
    return undefined
  }
  return `${BLOB_BASE_URL}/${IMAGE_KEY_OVERRIDES[imageName] ?? `${imageName}.svg`}`
}
